module.exports = __webpack_public_path__ + "static/media/car-make-grey.cb2cdb68.svg";